"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgebraFactory = void 0;
const algebra_transformations_1_2_1 = require("@traqula/algebra-transformations-1-2");
const TypesComunica_1 = require("./TypesComunica");
class AlgebraFactory extends algebra_transformations_1_2_1.AlgebraFactory {
    createNodes(graph, variable) {
        return {
            type: TypesComunica_1.TypesComunica.NODES,
            graph,
            variable,
        };
    }
    createDistinctTerms(variables, terms) {
        return {
            type: TypesComunica_1.TypesComunica.DISTINCT_TERMS,
            variables,
            terms,
        };
    }
}
exports.AlgebraFactory = AlgebraFactory;
//# sourceMappingURL=AlgebraFactory.js.map